import Status, {
  StatusVariant,
} from "@/modules/common/components/ui-kit/status/status";
import { ListingStatus } from "@/modules/property-tracks/types";
import { SemanticIndicatorColors } from "@/styles/nawy-theme/foundation/colors/semantic";

interface StatusProps {
  variant: StatusVariant;
  color: SemanticIndicatorColors;
}

const ListingStatusItemMapping: Record<ListingStatus, StatusProps> = {
  [ListingStatus.UNPUBLISHED]: {
    color: "grey",
    variant: "secondary",
  },
  [ListingStatus.PUBLISHED]: {
    color: "green",
    variant: "secondary",
  },
  [ListingStatus.UNPUBLISHED_EDITS]: {
    color: "orange",
    variant: "secondary",
  },
};

export default function ListingStatusItem({
  status,
}: {
  status: ListingStatus | undefined;
}) {
  if (!status) return;

  return (
    <Status
      label={status}
      variant={ListingStatusItemMapping[status].variant ?? "secondary"}
      color={ListingStatusItemMapping[status].color}
      width="auto"
    />
  );
}
